import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SubmenuDesktop from '../Submenu'

import * as S from './styled'

const MenuItemDesktop = ({ menuItem: { title, url, wordpress_children: submenu } }) => {
  const [submenuVisible, setSubmenuVisible] = useState(false)
  const hasSubmenu = submenu && submenu.length > 0

  const handleTag = (eventLabel) => {
    if (window && window.dataLayer)
      window.dataLayer.push({
        'event': 'institucional_header',
        'action': 'clicou_btn',
        'clique': eventLabel
      })
  }

  return (
    <S.MenuItem
      id='MenuItem-li'
      className='MenuItem-li'
      data-testid='menuitem-li'
      onMouseEnter={() => setSubmenuVisible(true)}
      onMouseLeave={() => setSubmenuVisible(false)}
      onClick={() => setSubmenuVisible(isVisible => !isVisible)}
    >
      {hasSubmenu ? (
        <>
          <S.SubmenuTitle
            id='SubmenuTitle-p'
            className='SubmenuTitle-p'
            data-testid='submenutitle-p'
            visible={submenuVisible}
          >
            {title}
          </S.SubmenuTitle>
          <SubmenuDesktop menu={title} submenu={submenu} visible={submenuVisible} />
        </>
      ) : (
        <S.MenuLink
          id='MenuLink-a'
          className='MenuLink-a'
          data-testid='menulink-p'
          data-item-text={title}
          data-item-position="Menu Header"
          data-current-service="Home"
          href={url === '' ? '#' : url}
          onClick={() => handleTag(title)}
        >
          {title}
        </S.MenuLink>
      )}
    </S.MenuItem>
  )
}

MenuItemDesktop.propTypes = {
  menuItem: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    wordpress_children: PropTypes.array,
  }),
}

export default MenuItemDesktop
